import { render } from "./spinnerText.vue?vue&type=template&id=a22af5fa"
import script from "./spinnerText.vue?vue&type=script&lang=js"
export * from "./spinnerText.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__